export default {
    chainProtocol: [{
        chain: 'bnb',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'PancakeInfCl', 'CurveStable'],
    }, {
        chain: 'eth',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'CurveStable'],
    }, {
        chain: 'base',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'PancakeInfCl', 'Aero', 'CurveStable'],
    }, {
        chain: 'robinhood',
        protocol: ['UniswapV2', 'UniswapV3', 'UniswapV4', 'PancakeSwapV2', 'PancakeSwapV3', 'CurveStable'],
    }],
}
